export default __webpack_public_path__ + "static/doodle-eaaf248e4729f15996279880d7e2f50e.png";